import { useEffect, useRef, useState } from "react";
import { observer } from "mobx-react";
import { useSearchParams } from "react-router-dom";

import { Loading } from "../../..";
import { useStore } from "../../../../store";
import { toast } from "react-toastify";
import TopBar from "./TopBar";
import ClassHeader from "./ClassHeader";
import ClassEnrollment from "./ClassEnrollment";
import AboutInstructor from "./AboutInstructor";
import ClassroomDetails from "./ClassroomDetails";
import Footer from "./Footer";

interface Props {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

function ClassSidebar({ isOpen, setIsOpen }: Props) {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("classId");

  const { courseStore, userStore } = useStore();

  const [loading, setLoading] = useState<boolean>(true);

  const course: any = courseStore.classDetails;

  const sendClassiewEvent = async () => {
    if (!sessionId) return;

    const payload = {
      event_name: "class_view",
      event_time: Math.floor(Date.now() / 1000),
      event_source_url: window.location.href,
      action_source: "website",
      user_data: {
        client_user_agent: navigator.userAgent,
        em: [userStore.user?.email || ""],
        ph: [userStore.user?.phone || ""],
        country: userStore.user?.country || "",
        ge: userStore.user?.gender || "",
        fn: userStore.user?.fullName || "",
        ln: userStore.user?.fullName || "",
      },
      custom_data: {
        class_id: sessionId,
        class_name: course?.title || "Unknown Class",
      },
    };

    try {
      await userStore.sendMetaEvent("course_view", payload);
    } catch (error) {
      console.error("Error sending event:", error);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    loadData();
  }, [sessionId]);

  const loadData = async () => {
    setLoading(true);
    try {
      if (sessionId) {
        await courseStore.getCohortById(sessionId);
        sendClassiewEvent();
      }
      if (!userStore.user) {
        await userStore.getUser();
      }
    } catch (error) {
      toast.error("Error loading course data");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-30 z-50"
          onClick={() => setIsOpen(false)}
        />
      )}
      <div
        className={`fixed inset-y-0 right-0 bg-blackShades-8 z-[999] transform ${
          isOpen ? "translate-x-0" : "translate-x-full"
        } transition-transform duration-300 ease-in-out w-[380px] sm:w-[580px] bg-white overflow-y-auto`}
      >
        {loading ? (
          <Loading />
        ) : (
          <>
            <TopBar setIsOpen={setIsOpen} />
            <ClassHeader />
            <ClassEnrollment />
            <AboutInstructor />
            <ClassroomDetails />
            <Footer />
          </>
        )}
      </div>
    </>
  );
}

export default observer(ClassSidebar);
